import { render, staticRenderFns } from "./ReducedebtHeader.vue?vue&type=template&id=686d162e&scoped=true&"
import script from "./ReducedebtHeader.vue?vue&type=script&lang=js&"
export * from "./ReducedebtHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReducedebtHeader.vue?vue&type=style&index=0&id=686d162e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d162e",
  null
  
)

export default component.exports